import type {
  CheckPointApiSettings,
  MerakiApiSettings,
  VendorApi,
} from './types';

export const getVendorApiDetails = (
  vendorApiSettings: Partial<VendorApi>,
): string => {
  if ('regions' in vendorApiSettings && !!vendorApiSettings.regions) {
    return vendorApiSettings.regions!.join(', ');
  }
  return (
    (vendorApiSettings as CheckPointApiSettings).domains ??
    (vendorApiSettings as MerakiApiSettings).organizations ??
    []
  ).join(', ');
};
